import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router'
import classNames from 'classnames'
import './Button.css'

const Button = props => {
  const attrs = {
    disabled: props.disabled || props.loading || null,
    form: props.form || null,
    'data-icon': props.icon || null,
    'data-modifier': props.modifier,
    onClick: props.onClick,
    'data-extras': props.extras,
    className: classNames({
      'ui-Button': true,
      'ui-Button--large': props.size === 'large',
      'ui-Button--loading': props.loading
    }),
    'data-wide': props.wide,
    rel: props.rel,
    target: props.target,
    style: {
      width: props.width
    }
  }

  if (props.href) {
    // use `to={url}` to prevent full reload when. use
    // `href={url}` with `rel=external` to force reloads.
    const href =
      props.rel === 'external' ? { href: props.href } : { to: props.href }

    return (
      <Link {...attrs} {...href}>
        {props.children}
      </Link>
    )
  }

  return (
    <button {...attrs} type={props.type || 'button'}>
      {props.children}
    </button>
  )
}

Button.propTypes = {
  children: PropTypes.any,
  disabled: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  extras: PropTypes.string,
  form: PropTypes.string,
  href: PropTypes.string,
  icon: PropTypes.string,
  loading: PropTypes.bool,
  modifier: PropTypes.string,
  onClick: PropTypes.func,
  rel: PropTypes.string,
  size: PropTypes.string,
  target: PropTypes.string,
  type: PropTypes.string,
  wide: PropTypes.any
}

Button.displayName = 'Button'

export default Button



// WEBPACK FOOTER //
// ./ui/Button.js